import { useState } from "react";
import emailjs from "@emailjs/browser";

export default function Contact() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });

  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState("");

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    setLoading(true);
    setStatus("");

    try {
      await emailjs.send(
        process.env.REACT_APP_EMAILJS_SERVICE_ID,
        process.env.REACT_APP_EMAILJS_TEMPLATE_ID,
        {
          from_name: formData.name,
          from_email: formData.email,
          message: formData.message,
        },
        process.env.REACT_APP_EMAILJS_PUBLIC_KEY
      );

      setStatus("success");

      setFormData({
        name: "",
        email: "",
        message: "",
      });
    } catch (error) {
      console.error(error);
      setStatus("error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="mil-content">

      <div className="mil-scroll-wrapper transition-fade" id="swupMain">
        <div className="mil-container">
          <section className="mil-banner-sm mil-center">
            <div className="mil-banner-top mil-up"></div>
            <div className="mil-banner-title">
              <h1 className="mil-h1-sm mil-up mil-mb-60">Get in touch!</h1>
              <ul className="mil-breadcrumbs mil-up">
                <li><a href="home-1.html">Homepage</a></li>
                <li><a href="contact.html">Contact</a></li>
              </ul>
            </div>
          </section>

          <div>
            <ul className="mil-puplication-details mil-up mil-mb-90">
              <li><span className="mil-upper mil-accent">Call: </span>&nbsp;&nbsp;<span className="mil-upper mil-dark">+27(034)765 64 X5</span></li>
              <li><span className="mil-upper mil-accent">Write: </span>&nbsp;&nbsp;<span className="mil-upper mil-dark">miller.themes@gmail.com</span></li>
            </ul>
          </div>

          <div className="mil-map mil-mb-90">
            <iframe src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d1396.5769090312324!2d-73.6519672!3d45.5673453!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4cc91f8abc30e0ff%3A0xfc6d9cbb49022e9c!2sManoir%20Saint-Joseph!5e0!3m2!1sen!2sua!4v1685485811069!5m2!1sen!2sua" style={{ "border": "0" }} allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
          </div>

          <div className="mil-section-title mil-up">
            <div className="mil-divider"></div>
            <h3>Let's Talk</h3>
          </div>

          {/* <div id="contact" className="mil-p-90-60">
                        <form className="row align-items-center">
                            <div className="col-lg-6 mil-up">
                                <input type="text" placeholder="What's your name" />
                            </div>
                            <div className="col-lg-6 mil-up">
                                <input type="email" placeholder="Your Email" />
                            </div>
                            <div className="col-lg-12 mil-up">
                                <textarea placeholder="Tell us about our project"></textarea>
                            </div>
                            <div className="col-lg-8">
                                <p className="mil-up mil-mb-30"><span className="mil-accent">*</span> We promise not to disclose your personal information to third parties.</p>
                            </div>
                            <div className="col-lg-4">
                                <div className="mil-adaptive-right mil-up mil-mb-30">
                                    <button type="submit" className="mil-btn mil-sm-btn">
                                        <span>Send message</span>
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div> */}

          <div id="contact" className="mil-p-90-60">
            <form className="row align-items-center" onSubmit={handleSubmit}>

              <div className="col-lg-6 mil-up">
                <input
                  type="text"
                  name="name"
                  placeholder="What's your name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="col-lg-6 mil-up">
                <input
                  type="email"
                  name="email"
                  placeholder="Your Email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="col-lg-12 mil-up">
                <textarea
                  name="message"
                  placeholder="Tell us about your project"
                  rows="6"
                  value={formData.message}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="col-lg-8">
                <p className="mil-up mil-mb-30">
                  <span className="mil-accent">*</span>{" "}
                  We promise not to disclose your personal information to
                  third parties.
                </p>

                {status === "success" && (
                  <p style={{ color: "green" }}>
                    ✅ Thank you! Your message has been sent successfully.
                  </p>
                )}

                {status === "error" && (
                  <p style={{ color: "red" }}>
                    ❌ Something went wrong. Please try again.
                  </p>
                )}
              </div>

              <div className="col-lg-4">
                <div className="mil-adaptive-right mil-up mil-mb-30">
                  <button
                    type="submit"
                    className="mil-btn mil-sm-btn"
                    disabled={loading}
                  >
                    <span>
                      {loading ? "Sending..." : "Send Message"}
                    </span>
                  </button>
                </div>
              </div>

            </form>
          </div>

          <footer className="mil-fw">
            <p className="mil-light-soft">© 2023. Courtney. All rights reserved.</p>
            <p className="mil-light-soft">Author: &nbsp;<a href="https://themeforest.net/user/millerdigitaldesign/portfolio" target="_blank">Nazar Miller</a></p>
          </footer>

        </div>

      </div>

      <div className="mil-right-banner" id="scene">
        <div className="mil-progress-track">
          <div className="mil-progress"></div>
        </div>
        <div className="mil-banner-wrapper" data-depth="1">
          <div id="swupBg" className="mil-banner-frame">
            <img src="img/person/bg-2.jpg" alt="background" className="mil-banner-bg mil-blur" />
          </div>
        </div>
        <div className="mil-banner-wrapper" data-depth="0.2">
          <div id="swupPerson" className="mil-banner-frame">
            <img src="img/person/7.png" alt="person" className="mil-banner-person" />
          </div>
        </div>
        <div className="mil-flying-skills" data-depth="0.1">
          <div id="swupSkills" className="mil-skills-frame">
            <div className="mil-item" style={{ "top": "30%", "left": "10%" }}>
              <img src="img/logos/1.jpg" alt="logo" />
            </div>
            <div className="mil-item" style={{ "bottom": "15%", "left": "20%" }}>
              <img src="img/logos/2.jpg" alt="logo" />
            </div>
            <div className="mil-item" style={{ "bottom": "45%", "right": "15%" }}>
              <img src="img/logos/3.jpg" alt="logo" />
            </div>
            <div className="mil-el mil-addition-el-1">+</div>
            <div className="mil-el mil-addition-el-2">+</div>
            <div className="mil-el mil-addition-el-3"></div>
            <div className="mil-el mil-addition-el-4"></div>
          </div>
        </div>
      </div>

    </div>
  )
}
